import React from "react";
import { Survey, IndicatorReportDataSet, SurveySegment } from "../../../../../../../amorg-common";
import { Flex } from "../../../../../../../designSystem/compositeComponents/FlexHelpers";
import { P } from "../../../../../../../designSystem/typography/Body";
import { H3 } from "../../../../../../../designSystem/typography/Heading";
import { QuestionSummaryPanel } from "./QuestionSummaryPanel";
type IndicatorPanelProps = {
    survey: Survey,
    data: IndicatorReportDataSet[],
    segmentFilter: SurveySegment[][],
    showComments:boolean,
    siteId:string,
}
export function IndicatorPanel(props: IndicatorPanelProps): JSX.Element {

    return (
        <>
            {props.data.map(ir => 
                <QuestionSummaryPanel
                    key={ir.indicator}
                    survey={props.survey}
                    header={
                        <Flex flexDirection="column">
                            <H3>{ir.indicator}</H3>
                            <P>
                                Indikatoren er anvendt på {ir.questions.length} spørgsmål
                            </P>
                        </Flex>
                    }
                    siteId={props.siteId}
                    summaryStats={ir.stats}
                    questions={ir.questions}
                    segmentFilter={props.segmentFilter}
                    showComments={props.showComments} />
            )}
        </>
    );
}